"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const paths_1 = require("@/common/app/paths");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'admin-home',
    data() {
        return {
            paths: [
                paths_1.paths.API_STATS,
                paths_1.paths.GAMES_OVERVIEW,
                paths_1.paths.API_GAMES,
                paths_1.paths.API_METRICS,
                paths_1.paths.LOAD,
                paths_1.paths.API_IPS,
            ],
        };
    },
    computed: {
        serverId() {
            return new URLSearchParams(window.location.search).get('serverId') || '';
        },
    },
});
